/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    NAVIGATION_PLURALIZE_BROADCASTS
 * Date:         2026-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Pluralized "Broadcast" to "Broadcasts" in main navigation menu for consistency and UI clarity.
 *
 * Related Screens / Modules:
 * - client/src/constants/navigation.ts
 * - Main Navbar
 */

export type MainNavItem = {
  to: string;
  label: string;
  icon?: string; // public SVG path
  end?: boolean;
  requireAdmin?: boolean;
};

export const mainNavItems: MainNavItem[] = [
  { to: "/", label: "Dashboard", icon: "/assets/dashboard 1.svg", end: true },
  { to: "/inventory", label: "Inventory", icon: "/assets/inventory.svg" },
  // [2026-01-01] Navigation: Changed "Broadcast" to "Broadcasts"
  // Use /broadcast (end: false) so Broadcasts stays active on /broadcast/new, /broadcast/mine-all, etc.
  { to: "/broadcast", label: "Broadcasts", icon: "/assets/broadcast.svg", end: false },
  { to: "/admin", label: "Admin", icon: "/assets/admin-dashboard.svg", requireAdmin: true },
];
